export default __webpack_public_path__ + "static/media/phone-data2.445f568c.png";